import Typography from '@mui/material/Typography';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import useWizardJump from '@swf/core/hooks/useWizardJump';

import { ESRegulatoryErrorCode } from '../../../types/status';
import Prompt from '../../Prompt/Prompt';

import {
  TXTWCL_Alternatively_if_you_continue__ELL,
  TXTWCL_Alternatively_if_your_details__ELL,
  TXTWCL_If_you_do_not_have_another_Sta_ELL,
  TXTWCL_Online_Verification_Unsuccessf_ELL,
  TXTWCL_Please_review_and_amend_your_p_ELL_1,
  TXTWCL_ReasonX_Incorrect_Date_of_Birt_ELL,
  TXTWCL_ReasonX_Incorrect_First_Surnam_ELL,
  TXTWCL_ReasonX_Incorrect_Name,
  TXTWCL_ReasonX_Incorrect_Second_Surna_ELL,
  TXTWCL_ReasonX_Personal_Details_Alrea_ELL,
  TXTWCL_Review_Personal_Details,
  TXTWCL_Send_Documents,
  TXTWCL_Unfortunately_we_have_been_una_ELL,
  TXTWCL_Until_your_identity_has_been_v_ELL
} from './ESRegulatoryErrors.messages.json';

interface Props {
  code: string | null;
  onClose: () => void;
}

const ESRegulatoryErrorPrompts: React.FC<Props> = ({ code, onClose }) => {
  const { jumpBack, jumpForward } = useWizardJump();

  const renderBody = () => {
    switch (true) {
      case code === ESRegulatoryErrorCode.INCORRECT_FIRST_NAME:
        return (
          <>
            <Typography>
              <Translation {...TXTWCL_Unfortunately_we_have_been_una_ELL} />
            </Typography>
            <Typography>
              <Translation {...TXTWCL_ReasonX_Incorrect_Name} />
            </Typography>
            <Typography>
              <Translation {...TXTWCL_Until_your_identity_has_been_v_ELL} />{' '}
              <Translation {...TXTWCL_Please_review_and_amend_your_p_ELL_1} />
            </Typography>
            <Typography>
              <Translation {...TXTWCL_Alternatively_if_you_continue__ELL} />
            </Typography>
          </>
        );
      case code === ESRegulatoryErrorCode.INCORRECT_LAST_NAME:
        return (
          <>
            <Typography>
              <Translation {...TXTWCL_Unfortunately_we_have_been_una_ELL} />
            </Typography>
            <Typography>
              <Translation {...TXTWCL_ReasonX_Incorrect_First_Surnam_ELL} />
            </Typography>
            <Typography>
              <Translation {...TXTWCL_Until_your_identity_has_been_v_ELL} />{' '}
              <Translation {...TXTWCL_Please_review_and_amend_your_p_ELL_1} />
            </Typography>
            <Typography>
              <Translation {...TXTWCL_Alternatively_if_you_continue__ELL} />
            </Typography>
          </>
        );
      case code === ESRegulatoryErrorCode.INCORRECT_SECOND_LAST_NAME:
        return (
          <>
            <Typography>
              <Translation {...TXTWCL_Unfortunately_we_have_been_una_ELL} />
            </Typography>
            <Typography>
              <Translation {...TXTWCL_ReasonX_Incorrect_Second_Surna_ELL} />
            </Typography>
            <Typography>
              <Translation {...TXTWCL_Until_your_identity_has_been_v_ELL} />{' '}
              <Translation {...TXTWCL_Please_review_and_amend_your_p_ELL_1} />
            </Typography>
            <Typography>
              <Translation {...TXTWCL_Alternatively_if_you_continue__ELL} />
            </Typography>
          </>
        );
      case code === ESRegulatoryErrorCode.INCORRECT_DOB:
        return (
          <>
            <Typography>
              <Translation {...TXTWCL_Unfortunately_we_have_been_una_ELL} />
            </Typography>
            <Typography>
              <Translation {...TXTWCL_ReasonX_Incorrect_Date_of_Birt_ELL} />
            </Typography>
            <Typography>
              <Translation {...TXTWCL_Until_your_identity_has_been_v_ELL} />{' '}
              <Translation {...TXTWCL_Please_review_and_amend_your_p_ELL_1} />
            </Typography>
            <Typography>
              <Translation {...TXTWCL_Alternatively_if_you_continue__ELL} />
            </Typography>
          </>
        );
      case code === ESRegulatoryErrorCode.ID_DUPLICATE_FOUND:
        return (
          <>
            <Typography>
              <Translation {...TXTWCL_Unfortunately_we_have_been_una_ELL} />
            </Typography>
            <Typography>
              <Translation {...TXTWCL_ReasonX_Personal_Details_Alrea_ELL} />
            </Typography>
            <Typography>
              <Translation {...TXTWCL_Until_your_identity_has_been_v_ELL} />{' '}
              <Translation {...TXTWCL_If_you_do_not_have_another_Sta_ELL} />
            </Typography>
          </>
        );
      default:
        return (
          <>
            <Typography>
              <Translation {...TXTWCL_Unfortunately_we_have_been_una_ELL} />{' '}
              <Translation {...TXTWCL_Until_your_identity_has_been_v_ELL} />{' '}
              <Translation {...TXTWCL_Please_review_and_amend_your_p_ELL_1} />
            </Typography>
            <Typography>
              <Translation {...TXTWCL_Alternatively_if_your_details__ELL} />
            </Typography>
          </>
        );
    }
  };
  return (
    <Prompt
      onClose={onClose}
      title={{ translation: TXTWCL_Online_Verification_Unsuccessf_ELL }}
      variant="default"
      primaryButton={
        code !== ESRegulatoryErrorCode.CLOSE_RM_FORM
          ? { translation: TXTWCL_Review_Personal_Details }
          : { translation: TXTWCL_Send_Documents }
      }
      onPrimaryButtonClick={() => {
        code !== ESRegulatoryErrorCode.CLOSE_RM_FORM
          ? jumpBack('#rmf.rmf-legal-name')
          : jumpForward('#rmf.rmf-verification');
      }}
      {...(code !== ESRegulatoryErrorCode.CLOSE_RM_FORM && {
        secondaryButton: { translation: TXTWCL_Send_Documents }
      })}
      onSecondaryButtonClick={() => jumpForward('#rmf.rmf-verification')}
    >
      {renderBody()}
    </Prompt>
  );
};

export default ESRegulatoryErrorPrompts;
